import React from 'react';
import moment from 'moment';
import autobind from 'autobind-decorator';
import { inject, observer } from 'mobx-react';
import { Route, NavLink } from 'react-router-dom';

import MusicLibrary from 'common/components/music-library';

import { BandAccount, Albums, Music, BandPhotos } from 'client/artist-ui/components/artist';

import Dashboard from './cms/dashboard/dashboard';

import ArtistInfoHeader from './artist-info-header';
import EditArtistForm from './edit-artist-form';

@inject('artistStore', 'userStore', 'songsStore', 'genreStore')
@observer
class EditArtist extends React.Component {
	constructor (props) {
		super(props);

		const { _id } = this.props.artistStore.data.artist.toPOJO();
		this.props.songsStore.fetchSongsByArtist(_id);
	}

	render () {
		const { artistStore } = this.props;
		// const { match: {params: _id}} = this.props;
		const { _id } = artistStore.data.artist.toPOJO();

		console.log(_id);
		return (
			<div className="artist-info-comp" onClick={ this.onClick }>
				<div className="grid-x">
					<div className="cell">
						<ArtistInfoHeader />
					</div>

					<div className="cell">
						<nav>
						<ul className="menu horizontal artist-nav">
							<li><NavLink to={ `/artist/info/${_id}` }>Profile</NavLink></li>
							<li><NavLink to={ `/artist/library/${_id}` }>TEST</NavLink></li>
							{/* <li><NavLink to={ `/artist/library/${_id._id}` }>Tracks</NavLink></li>
							<li><NavLink to={ `/artist/albums/${_id._id}` }>Albums</NavLink></li>
							<li><NavLink to={ `/artist/photos/${_id._id}` }>Photos</NavLink></li>
							<li><NavLink to={ `/artist/dashboard/${_id._id}` }>Dashboard</NavLink></li> */}
						</ul>
						</nav>
					</div>

					<div className="cell padding-1">
						<Route path="/artist/info/:_id" exact render={ () => <EditArtistForm /> } />

						<Route path="/artist/library/:_id" exact render={ () => <BandAccount rowUserID={ _id } /> } />
						{/* <Route path="/artist/library/:_id" exact render={ () => <Music rowUserID={ _id._id} /> } />
						<Route path="/artist/albums/:_id" exact render={ () => <Albums rowUserID={ _id } /> } />
						<Route path="/artist/photos/:_id" exact render={ () => <BandPhotos rowUserID={ _id }/> } />
						<Route path="/artist/dashboard/:_id" exact render={ () => <Dashboard rowUserID={ _id } /> } /> */}
					</div>
				</div>
			</div>
		);
	}

	@autobind
	onClick ({ target: { classList } }) {
		if (classList.contains('button') || classList.contains('delete-button-container')) {

			return;
		}

		const { songsStore } = this.props;
		songsStore.activeSongRowID = null;
	}
}

export default EditArtist;
